import { useState, useEffect } from 'react';

const API = import.meta.env.VITE_API_URL || '/api';

export default function Settings() {
  const [settings, setSettings] = useState({ site_name: 'CosmicHindu', free_shipping_threshold: 999, gst_percent: 18, support_email: '', support_phone: '', upi_id: '' });
  const [pwForm, setPwForm] = useState({ current: '', newPw: '', confirm: '' });
  const [saving, setSaving] = useState(false);
  const [pwSaving, setPwSaving] = useState(false);
  const [msg, setMsg] = useState('');
  const [pwMsg, setPwMsg] = useState('');
  const token = localStorage.getItem('admin_token');

  useEffect(() => {
    fetch(`${API}/get-settings.php`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.json()).then(d => { if (d.settings) setSettings(s => ({ ...s, ...d.settings })); }).catch(() => {});
  }, []);

  const saveSettings = async (e) => {
    e.preventDefault(); setSaving(true); setMsg('');
    const r = await fetch(`${API}/update-settings.php`, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify(settings),
    }).then(r => r.json()).catch(() => ({ success: false }));
    setSaving(false);
    setMsg(r.success ? '✅ Settings saved!' : `❌ ${r.message || 'Error'}`);
  };

  const changePassword = async (e) => {
    e.preventDefault();
    if (pwForm.newPw !== pwForm.confirm) { setPwMsg('❌ Passwords do not match'); return; }
    setPwSaving(true); setPwMsg('');
    const r = await fetch(`${API}/change-password.php`, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify({ current_password: pwForm.current, new_password: pwForm.newPw }),
    }).then(r => r.json()).catch(() => ({ success: false }));
    setPwSaving(false);
    setPwMsg(r.success ? '✅ Password changed!' : `❌ ${r.message || 'Error'}`);
    if (r.success) setPwForm({ current: '', newPw: '', confirm: '' });
  };

  const row = (label, name, type = 'text', placeholder = '') => (
    <div style={{ marginBottom: '1.1rem' }}>
      <label style={{ display: 'block', fontFamily: "'Cinzel',serif", fontSize: '.62rem', letterSpacing: '.18em', textTransform: 'uppercase', color: 'rgba(255,184,0,.6)', marginBottom: '.4rem' }}>{label}</label>
      <input type={type} value={settings[name] || ''} onChange={e => setSettings({ ...settings, [name]: e.target.value })} placeholder={placeholder}
        style={{ width: '100%', padding: '.75rem .9rem', background: 'rgba(255,255,255,.06)', border: '1px solid rgba(255,184,0,.22)', borderRadius: 6, color: '#FFE082', fontFamily: "'Crimson Pro',serif", fontSize: '.9rem', outline: 'none', boxSizing: 'border-box' }} />
    </div>
  );

  const pwRow = (label, name, placeholder) => (
    <div style={{ marginBottom: '1.1rem' }}>
      <label style={{ display: 'block', fontFamily: "'Cinzel',serif", fontSize: '.62rem', letterSpacing: '.18em', textTransform: 'uppercase', color: 'rgba(255,184,0,.6)', marginBottom: '.4rem' }}>{label}</label>
      <input type="password" value={pwForm[name] || ''} onChange={e => setPwForm({ ...pwForm, [name]: e.target.value })} placeholder={placeholder}
        style={{ width: '100%', padding: '.75rem .9rem', background: 'rgba(255,255,255,.06)', border: '1px solid rgba(255,184,0,.22)', borderRadius: 6, color: '#FFE082', fontFamily: "'Crimson Pro',serif", fontSize: '.9rem', outline: 'none', boxSizing: 'border-box' }} />
    </div>
  );

  const Box = ({ title, children }) => (
    <div style={{ background: 'linear-gradient(135deg,rgba(20,4,0,.98),rgba(26,10,46,.98))', border: '1px solid rgba(255,184,0,.22)', borderRadius: 10, padding: '2rem', marginBottom: '1.5rem' }}>
      <h3 style={{ fontFamily: "'Cinzel',serif", fontSize: '.75rem', letterSpacing: '.2em', textTransform: 'uppercase', color: '#FFB800', marginBottom: '1.5rem' }}>{title}</h3>
      {children}
    </div>
  );

  const Msg = ({ m }) => m ? <div style={{ padding: '.75rem 1rem', borderRadius: 6, marginBottom: '1rem', background: m.startsWith('✅') ? 'rgba(76,175,80,.15)' : 'rgba(192,57,43,.15)', border: `1px solid ${m.startsWith('✅') ? 'rgba(76,175,80,.3)' : 'rgba(192,57,43,.3)'}`, fontFamily: "'Cinzel',serif", fontSize: '.75rem', color: m.startsWith('✅') ? '#4CAF50' : '#ff6b6b' }}>{m}</div> : null;

  return (
    <div>
      <h1 style={{ fontFamily: "'Cinzel Decorative',serif", fontSize: '1.5rem', background: 'linear-gradient(135deg,#FFE082,#FF6B00)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', marginBottom: '1.8rem' }}>⚙️ Settings</h1>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(400px,1fr))', gap: '1.5rem' }}>
        <div>
          <Box title="🏬 Store Settings">
            <Msg m={msg} />
            <form onSubmit={saveSettings}>
              {row('Site Name', 'site_name', 'text', 'CosmicHindu')}
              {row('Free Shipping Threshold (₹)', 'free_shipping_threshold', 'number', '999')}
              {row('GST Percentage (%)', 'gst_percent', 'number', '18')}
              {row('Support Email', 'support_email', 'email', 'support@cosmichindu.com')}
              {row('Support Phone', 'support_phone', 'text', '+91 98765 43210')}
              {row('UPI ID', 'upi_id', 'text', 'cosmichindu@upi')}
              <button type="submit" disabled={saving}
                style={{ padding: '.9rem 2rem', background: 'linear-gradient(135deg,#FF6B00,#FFB800)', border: 'none', borderRadius: 6, color: '#0D0500', fontFamily: "'Cinzel',serif", fontSize: '.78rem', fontWeight: 700, letterSpacing: '.15em', textTransform: 'uppercase', cursor: saving ? 'not-allowed' : 'pointer' }}>
                {saving ? '🌀 Saving…' : '💾 Save Settings'}
              </button>
            </form>
          </Box>
        </div>

        <div>
          <Box title="🔐 Change Password">
            <Msg m={pwMsg} />
            <form onSubmit={changePassword}>
              {pwRow('Current Password', 'current', 'Current password')}
              {pwRow('New Password', 'newPw', 'New password (min 8 chars)')}
              {pwRow('Confirm New Password', 'confirm', 'Repeat new password')}
              <button type="submit" disabled={pwSaving}
                style={{ padding: '.9rem 2rem', background: 'linear-gradient(135deg,#FF6B00,#FFB800)', border: 'none', borderRadius: 6, color: '#0D0500', fontFamily: "'Cinzel',serif", fontSize: '.78rem', fontWeight: 700, letterSpacing: '.15em', textTransform: 'uppercase', cursor: pwSaving ? 'not-allowed' : 'pointer' }}>
                {pwSaving ? '🌀 Updating…' : '🔐 Change Password'}
              </button>
            </form>
          </Box>

          <Box title="ℹ️ System Info">
            {[['Version', '2.0.0'],['Environment', import.meta.env.MODE || 'production'],['API Endpoint', import.meta.env.VITE_API_URL || '/api'],['Build', new Date().getFullYear()]].map(([k, v]) => (
              <div key={k} style={{ display: 'flex', justifyContent: 'space-between', padding: '.5rem 0', borderBottom: '1px solid rgba(255,184,0,.07)' }}>
                <span style={{ fontFamily: "'Cinzel',serif", fontSize: '.65rem', letterSpacing: '.12em', textTransform: 'uppercase', color: 'rgba(255,184,0,.5)' }}>{k}</span>
                <span style={{ fontFamily: "'Crimson Pro',serif", fontSize: '.88rem', color: '#FFE082' }}>{v}</span>
              </div>
            ))}
          </Box>
        </div>
      </div>
    </div>
  );
}
